import { render, staticRenderFns } from "./OsInternalUsersOverview.vue?vue&type=template&id=498dbb2e&scoped=true"
import script from "./OsInternalUsersOverview.vue?vue&type=script&lang=ts"
export * from "./OsInternalUsersOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498dbb2e",
  null
  
)

export default component.exports